<div class="simple-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="dialog-title">
      <mat-icon>{{ icon }}</mat-icon>
      <h2>{{ title }}</h2>
    </div>

    <button mat-icon-button type="button" [attr.aria-label]="'common.buttons.close' | transloco" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form">
      <mat-form-field appearance="outline" >
        <mat-label>{{ 'dataManagement.organizationSettings.fields.companyName' | transloco }}</mat-label>
        <input matInput formControlName="companyName" />

        <mat-error *ngIf="form.get('companyName')?.hasError('required')">
          {{ 'dataManagement.organizationSettings.validation.companyNameRequired' | transloco }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" >
        <mat-label>{{ 'dataManagement.organizationSettings.fields.streetAndHouseNumber' | transloco }}</mat-label>
        <input matInput formControlName="address" />

        <mat-error *ngIf="form.get('address')?.hasError('required')">
          {{ 'dataManagement.organizationSettings.validation.streetRequired' | transloco }}
        </mat-error>
      </mat-form-field>

      <div class="address-row">
       <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.postalCode' | transloco }}</mat-label>
          <input matInput formControlName="postCode" />

          <mat-error *ngIf="form.get('postCode')?.hasError('required')">
            {{ 'dataManagement.organizationSettings.validation.postalCodeRequired' | transloco }}
          </mat-error>
        </mat-form-field>

       <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.city' | transloco }}</mat-label>
          <input matInput formControlName="city" />

          <mat-error *ngIf="form.get('city')?.hasError('required')">
            {{ 'dataManagement.organizationSettings.validation.cityRequired' | transloco }}
          </mat-error>
        </mat-form-field>

       <mat-form-field appearance="outline">
          <mat-label>{{ 'dataManagement.organizationSettings.fields.country' | transloco }}</mat-label>
          <mat-select formControlName="location">
            <mat-option *ngFor="let country of countries" [value]="country.futureId">
              {{ country.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('location')?.hasError('required')">
            {{ 'dataManagement.organizationSettings.validation.countryRequired' | transloco }}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" (click)="closeDialog()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>

    <button mat-raised-button color="primary" type="button" (click)="doAction()">
      {{ (isEditMode ? 'common.buttons.save' : 'common.buttons.create') | transloco }}
    </button>
  </mat-dialog-actions>
</div>
